import { useNavigate } from "react-router-dom";

export default function SignUp() {
  const navigate = useNavigate();
  return (
    <div className="onboarding-container">
      <div className="onboard-content d-flex">
        <div className="empoweredman-image"></div>
        <div className="get-started">
          <div
            style={{
              justifyContent: "center",
              alignItems: "center",
              textAlign: "center",
            }}
          >
            <div>
              <img
                style={{ width: "109.35px", height: "123.93px" }}
                src="/images/brave.png"
                alt=""
              />
            </div>
            <div
              className="d-flex flex-column"
              style={{ gap: "32px", marginTop: "32px" }}
            >
              <div className="d-flex flex-column" style={{ gap: "12px" }}>
                <h1
                  style={{
                    color: "rgba(230, 236, 241, 1)",
                    fontFamily: "Poppins",
                    fontWeight: 600,
                    fontSize: "36px",
                    lineHeight: "57px",
                  }}
                >
                  Welcome To <br /> Empowered Man!
                </h1>
                <span
                  style={{
                    color: "rgba(230, 236, 241, 1)",
                    fontFamily: "Poppins",
                    fontWeight: 400,
                    fontSize: "16px",
                    lineHeight: "24px",
                  }}
                >
                  Your personal power weapon
                </span>
              </div>
              <div>
                <button
                  className="get-started-btn"
                  onClick={() => navigate("/sign-up")}
                  style={{ width: "240px" }}
                >
                  Create an account
                </button>
              </div>
              <div>
                <span
                  style={{
                    color: "rgba(208, 216, 223, 1)",
                    fontSize: "14px",
                    fontWeight: 400,
                    lineHeight: "14px",
                    cursor: "pointer",
                  }}
                >
                  Already have an account?{" "}
                  <span
                    style={{ color: "rgba(102, 186, 255, 1)" }}
                    onClick={() => navigate("/login")}
                  >
                    Sign In
                  </span>
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
